module.exports = __webpack_public_path__ + "static/media/logo-test.21480df7.svg";